<template>
  <div>
    <el-container class="max">
      <el-aside width="260px">
        <el-menu class="api_menu" :default-active="active" :default-openeds="opens">
          <el-submenu :index="item.title" v-for="item in menu" :key="item.id.toString()">
            <template slot="title">
              <span>{{ item.title }}</span>
            </template>
            <el-menu-item v-for="i in item.openApiList" :key="i.id" :index="`${item.id}-${i.name}`"
                          @click="showPage(i)" :class="parseInt($route.query.id) === parseInt(i.id) ? 'active' : ''">
              {{ i.name }}
            </el-menu-item>
          </el-submenu>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
    <el-dialog title="开发者登录" :visible.sync="loginDialog" width="450px" @close="clickCancel"
               :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form label-width="0" class="demo-ruleForm">
          <el-form-item>
            <el-input v-model="form.loginName" auto-complete="off" placeholder="用户名"
                      prefix-icon="el-icon-user"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="password" v-model="form.password" auto-complete="off" placeholder="密码"
                      prefix-icon="el-icon-lock"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="clickCancel">取 消</el-button>
        <el-button type="primary" @click="toLogin">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'openApi',
  data () {
    return {
      form: {loginName: '', password: '', device: 'from b2b'},
      loginDialog: false,
      menu: this.$store.getters.getMenuList,
      active: '',
      opens: [],
      queryId: ''
    }
  },
  created () {
    this.checkLogin()
  },
  watch: {
    '$route.path': {
      handler (val) {
        if (val === '/view/index/openApi') {
          this.checkLogin()
        }
      },
      immediate: true
    }
  },
  methods: {
    async checkLogin () {
      let jsonStr = localStorage.getItem('openApiPartnerInfo')
      if (jsonStr) {
        let info = JSON.parse(jsonStr)
        const {data: result} = await this.$http.get('/mini/checkToken', {headers: {accessToken: info.token}})
        this.loginDialog = result.code !== 200
        if (!this.loginDialog) {
          await this.searchOpenApiInfos()
        } else {
          await this.$router.push({
            path: '/view/index/openApi',
            query: {id: this.$route.query.id}
          })
        }
      } else {
        await this.$router.push({
          path: '/view/index/openApi',
          query: {id: this.$route.query.id}
        })
        this.loginDialog = true
      }
    },
    formatJSON () {
      this.menu.forEach(item => {
        item.openApiList.forEach(i => {
          if (i.type === 1) {
            this.$set(i, 'requestParams', this.formatArr(i.requestParams))
            this.$set(i, 'responseBody', this.formatArr(i.responseBody))
            this.$set(i, 'requestExample', this.formatObj(i.requestExample))
            this.$set(i, 'responseExample', this.formatObj(i.responseExample))
          }
        })
      })
    },
    formatObj (str) {
      if (!str) return {}
      try {
        return JSON.parse(str)
      } catch (e) {
        return {}
      }
    },
    formatArr (str) {
      if (!str) return []
      try {
        return JSON.parse(str)
      } catch (e) {
        return []
      }
    },
    async searchOpenApiInfos () {
      let jsonStr = localStorage.getItem('openApiPartnerInfo')
      if (jsonStr) {
        let info = JSON.parse(jsonStr)
        const {data: result} = await this.$http.get('/mini/searchOpenApiInfos', {headers: {accessToken: info.token}})
        if (result.code !== 200) return
        this.menu = result.data
        this.formatJSON()
        await this.$store.commit('setMenuList', result.data)
        if (this.menu && this.menu[0].openApiList) {
          let queryId = this.$route.query.id
          let menuIndex = 0
          let interfaceIndex = 0
          if (queryId) {
            this.menu.forEach((item, index) => {
              item.openApiList.forEach((i, ind) => {
                if (parseInt(i.id) === parseInt(queryId)) {
                  menuIndex = index
                  interfaceIndex = ind
                  return
                }
              })
            })
          }
          this.active = `${this.menu[menuIndex].id}-${this.menu[menuIndex].openApiList[interfaceIndex].id}`
          if (!this.opens.includes(this.menu[menuIndex].title)) {
            this.opens.push(this.menu[menuIndex].title)
          }
          if (this.queryId) {
            this.showPage({id: this.queryId})
          } else {
            this.showPage(this.menu[menuIndex].openApiList[interfaceIndex])
          }
        }
      }
    },
    clickCancel () {
      this.$router.go(-1)
      this.loginDialog = false
    },
    async toLogin () {
      if (!this.form.loginName) return this.$message.warning('请输入用户名')
      if (!this.form.password) return this.$message.warning('请输入密码')
      const {data: result} = await this.$http.post('/mini/loginByName', this.form)
      if (result.code !== 200) return this.$message.error(result.message)
      await localStorage.setItem('openApiPartnerInfo', JSON.stringify(result.data))
      await this.searchOpenApiInfos()
      this.loginDialog = false
    },
    showPage (row) {
      if (row.type === 1) {
        this.$router.push({
          path: '/view/index/openApi/interface',
          query: {
            id: row.id
          }
        })
      } else {
        this.$router.push({
          path: '/view/index/openApi/doc',
          query: {
            id: row.id
          }
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.max {
  min-height: calc(100vh - 70px);
  background-color: #f0f2f5;

  & /deep/ .api_menu {
    height: 100%;
  }

  & /deep/ .el-submenu__title {
    border-top: 1px solid #eaeaea;
  }

  & /deep/ .el-submenu .el-menu-item.active {
    background-color: #eff3fe;
    color: #409eff;
  }

  & /deep/ .el-menu-item.is-active {
    color: #000;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newWebsite/main/openApi.vue